class OpeningAnimation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    const cover = document.querySelector(".js-opening");
    const title = document.querySelector(".js-openingTitle");
    const text = document.querySelector(".js-openingText");
    const header = document.querySelector(".l-header");
    const sideBtn = document.querySelector(".side-btn");
    const scrollDown = document.querySelector(".scroll-down");
    const jsBefore = document.querySelector(".js-Before");
    const spTelButton = document.querySelector(".spTel-btn");
  
    cover.classList.add('is-open');
    title.classList.add('is-open');
    text.classList.add('is-open');
    header.classList.add('is-open');
    sideBtn.classList.add('is-open');
    scrollDown.classList.add('is-open');
    jsBefore.classList.add('is-open');
    spTelButton.classList.add('is-open');
  }
}